const fileUploadurl = 'https://nexgen.sprintnxt.in/api/upload-normal-file';
const aesEnckey = '6fa979f20126cb08aa645a8f495f6d85';
const aesEnciv = 'I8zyA4lVhMCaJ5Kg';
const defEncKey = 'jy2hVH/mHvITAK&1Qs4udr1$NadtqwWT2SjdnSj2=';
const onboardurl = 'https://uatkyc.ciphersquare.in/kyc/front/#/kyc';
const domainName = 'uat.sprintnxt.in';
interface _InitEnv {
    production: boolean,
    domainName: string,
    frontend_url: string,
    baseurl: string,
    fileUploadurl: string,
    aesEnckey: string,
    aesEnciv: string,
    defEncKey: string,
    onboardurl: string,
    appVersion?: string,
}
interface _Env {
    production: _InitEnv,
    preProd: _InitEnv,
    uat: _InitEnv, 
    beta: _InitEnv,
    preUat: _InitEnv,
    onDemand: _InitEnv,
}

let urls: _Env = {
    production: {
        production: true,
        domainName: 'nexgen.sprintnxt.in',
        frontend_url: 'https://nexgen.sprintnxt.in/',
        baseurl: 'https://nexgen.sprintnxt.in/NexGenBackendV2.1/',
        fileUploadurl,
        aesEnckey,
        aesEnciv,
        defEncKey,
        onboardurl: 'https://nxtverify.sprintnxt.in/#/kyc',
        appVersion: require('../../package.json').version,
    },
    beta: {
        production: true,
        domainName: "nexgen.sprintnxt.in",
        frontend_url: 'https://beta.sprintnxt.in/',
        baseurl: 'https://beta.sprintnxt.in/NexGenBackendV2.1/',
        fileUploadurl,
        aesEnckey,
        aesEnciv,
        defEncKey,
        onboardurl,
    },
    preProd: {
        production: false,
        domainName:'nexgen.sprintnxt.in',
        frontend_url: 'https://uatkyc.ciphersquare.in/',
        baseurl: 'https://nexgen.sprintnxt.in/NexGenBackendV2/',
        fileUploadurl,
        aesEnckey,
        aesEnciv,
        defEncKey,
        onboardurl,
    },
    uat: {
        production: false,
        domainName: "pre.sprintnxt.in",
        frontend_url: 'https://pre.sprintnxt.in/',
        baseurl: 'https://uat.sprintnxt.in/PreNexGenBackendV2/',
        fileUploadurl,
        aesEnckey,
        aesEnciv,
        defEncKey,
        onboardurl,
    },
    preUat: {
        production: false,
        domainName,
        frontend_url: 'https://uatnxtgen.sprintnxt.in/',
        // baseurl: 'https://beta.sprintnxt.in/nexgen-2-0/',
        // baseurl: 'https://uat.sprintnxt.in/nexgen_backendV2/',
        // baseurl: 'http://172.16.10.251:8300/',
        // baseurl: 'http://172.16.10.248:82/',
        baseurl: 'https://uat.sprintnxt.in/NexGenBackendV2/',
        fileUploadurl,
        aesEnckey,
        aesEnciv,
        defEncKey,
        onboardurl,
        appVersion: require('../../package.json').version + '-dev',
    },
    onDemand: {
        production: true,
        domainName: "nexgen.sprintnxt.in",
        frontend_url: 'https://beta.sprintnxt.in/',
        baseurl: 'https://beta.sprintnxt.in/NexGenBackendV2/',
        fileUploadurl,
        aesEnckey,
        aesEnciv,
        defEncKey,
        onboardurl,
    },
}

export default urls;